<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{ titolo }}</span>
            <button mat-icon-button (click)="dialogRef.close(null)" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="content m-0 p-24" style="overflow: hidden;" fxLayout="column">
        <img width="350" [src]="captchaUrl" />
        <form [formGroup]="captchaForm" fxLayout="column" fxLayoutAlign="">
            <mat-form-field>
                <input matInput placeholder="Captcha" formControlName="captcha" />
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="p-24 m-0" align="end" fxLayoutGap="12px" >

        <button mat-raised-button type="button" [disabled]="captchaForm.invalid" color="accent" (click)="confermaCaptcha()">
            Conferma
        </button>
        <button mat-button type="button" (click)="dialogRef.close(null)">
            Annulla
        </button>
    </div>
</div>
